import {client} from '../helpers/api';

export async function getTeacherSchedules({gradeIds, subjectIds}) {
  const gradeIdsQs = gradeIds
    ? gradeIds.map((id) => `grade_id[]=${id}`).join('&') + '&'
    : '';
  const subjectIdsQs = subjectIds
    ? subjectIds.map((id) => `subject_id[]=${id}`).join('&')
    : '';

  const url = `/api/teacher_schedules?${gradeIdsQs}${subjectIdsQs}`;
  const response = await client.get(url);

  if (response.data?.status) {
    return (
      response.data?.data.map(
        ({
          schedule_id: scheduleId,
          _subject_id: subjectId,
          _grade_id: gradeId,
          _teacher_id: teacherId,
          week_day: weekDay,
          start_time: startTime,
          end_time: endTime,
          zoom_class_link: classLink,
          teacher_name: teacherName,
          teacher_image: teacherImage,
        }) => ({
          scheduleId,
          subjectId,
          gradeId,
          teacherId,
          weekDay,
          startTime,
          endTime,
          classLink,
          teacherName,
          teacherImage,
        }),
      ) || []
    );
  }
  throw response;
}

// {
//   "schedule_id": "2c576549-c9c3-46a9-a3b7-ed78f7d488fd",
//   "_subject_id": "830bde66-e7c6-4e53-9f96-6fb9ed8bb31c",
//   "_grade_id": "c6e482fb-e36b-4cc0-bd45-acaaf0f53723",
//   "_teacher_id": "09a41150-3f30-47a3-a198-ad49d7fe610f",
//   "week_day": "SUN",
//   "start_time": "10:00",
//   "end_time": "11:00",
//   "zoom_class_link": null,
//   "date_created": "2021-01-10 22:36:11",
//   "date_modified": "2021-01-10 22:36:11",
//   "status": "active",
//   "is_deleted": 0
// }
